module.exports = "/images/story_profile_2.png?149e72c5fe87d8833dd955e308aff65b";